import { render, staticRenderFns } from "./ParticipantList.vue?vue&type=template&id=481400ce"
import script from "./ParticipantList.vue?vue&type=script&lang=ts"
export * from "./ParticipantList.vue?vue&type=script&lang=ts"
import style0 from "./ParticipantList.vue?vue&type=style&index=0&id=481400ce&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports